import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class ClassroomService {
    static getClassrooms(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`classrooms?filter=${qs}`, pageNumber));
    }
    static fetchClassroom(oid) {
        return lastValueFrom(BaseService.get(`classrooms/${oid}`));
    }
    static saveClassroom(dto) {
        return lastValueFrom(BaseService.save(`classrooms`, dto));
    }
    static deleteClassroom(oid) {
        return lastValueFrom(BaseService.delete(`classrooms/${oid}`));
    }
    static searchClassroomCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`classrooms-search-dropdown/${selfId}?search=${qs}`));
    }
    static deleteClassroomAndMembers(oid) {
        return lastValueFrom(BaseService.delete(`classroom-and-members/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Stats
    // ----------------------------------------------------------------------
    // public static fetchClassroomStats(oid: number) {
    //   //return lastValueFrom(BaseService.get<IDossierStatsDTO>(`classrooms-stats/${oid}`));
    //   return null;
    // }
    // ----------------------------------------------------------------------
    // Participants
    // ----------------------------------------------------------------------
    static getClassroomParticipants(classroomId) {
        return lastValueFrom(BaseService.get(`classroom-participants/${classroomId}`));
    }
    static saveClassroomParticipant(dto) {
        return lastValueFrom(BaseService.save(`classroom-participants`, dto));
    }
    static deleteClassroomParticipant(oid) {
        return lastValueFrom(BaseService.delete(`classroom-participants/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Excel Upload
    // ----------------------------------------------------------------------
    static uploadClassroomExcel(classroomId, excel) {
        return lastValueFrom(BaseService.uploadFileEx(`classroom-excel-upload/${classroomId}`, excel));
    }
}
